import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { CalendarSong } from '../types';
import { calendarMessages } from './calendarMessages';
import { songArtworkUrl, songColourStyle } from './calendarPostView';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReleaseBandProps {
  song: CalendarSong;
  /** The panel says "is out today" on the release day of today. */
  isToday?: boolean;
}

/**
 * The release day of a song (design a1): the cover and "Forests is out", in the colour of the
 * song. The colour is the accent of its release theme, else the brand violet.
 */
const ReleaseBandComponent: React.FC<ReleaseBandProps> = ({ song, isToday = false }) => {
  const intl = useIntl();
  const cover = songArtworkUrl(song);
  return (
    <div className={styles.rel} style={songColourStyle(song)} data-testid={`release-band-${song.catalogItemUuid}`}>
      {cover === null ? <span className={styles.relCover} /> : <img className={styles.relCover} src={cover} alt="" />}
      <span>
        {intl.formatMessage(isToday ? calendarMessages.releaseToday : calendarMessages.releaseBand, {
          title: song.title,
        })}
      </span>
    </div>
  );
};

export const ReleaseBand = TypedMemo(ReleaseBandComponent);
